import React, { useState } from 'react';
import i18n from '../../utilities/i18n';
import { VStack, FilterButton, Popup } from '@adc/parallax-component-library';
import { IconFilter } from '@adc/parallax-icons';
import CheckboxFilterList from './filters/CheckboxFilterList';
import { CheckboxFilterSection, CheckboxFilterItem } from './DynamicTable';
import './TableFilters.scss';

interface TableFiltersProps {
  enableFiltering: boolean;
  checkboxFilters: CheckboxFilterSection[];
  activeFiltersCount: number;
  onFilterChange: (
    sectionId: CheckboxFilterSection['id'],
    item: CheckboxFilterItem,
  ) => void;
  onResetFilters: () => void;
}

export const TableFilters: React.FC<TableFiltersProps> = ({
  enableFiltering,
  checkboxFilters,
  activeFiltersCount,
  onFilterChange,
  onResetFilters,
}) => {
  const [isFiltersPopupOpen, setIsFiltersPopupOpen] = useState(false);

  if (!enableFiltering || !checkboxFilters?.length) {
    return null;
  }

  return (
    <Popup
      // @ts-expect-error Parallax Popup types are incorrect
      title={i18n.t('Filters.title')}
      headerExtra={{
        label: i18n.t('Filters.clearAll'),
        onPress: onResetFilters,
        disabled: activeFiltersCount === 0,
      }}
      content={
        <VStack
          className="table-filters-content-scrollable"
          justifyContent="center"
          alignItems="flex-start"
          minWidth={250}
          gap={'$2'}
        >
          {checkboxFilters.map((checkboxFilter) => (
            <CheckboxFilterList
              key={checkboxFilter.id}
              id={checkboxFilter.id}
              label={checkboxFilter.label}
              items={checkboxFilter.items}
              onChange={onFilterChange}
            />
          ))}
        </VStack>
      }
      contentPadding={true}
      placement="bottom"
      onOpenChange={setIsFiltersPopupOpen}
      testID="table-filters-popup"
    >
      <FilterButton
        iconStart={<IconFilter />}
        label={i18n.t('Filters.title')}
        aria-label={`${i18n.t('Filters.title')}: ${activeFiltersCount}`}
        badge={activeFiltersCount > 0 ? activeFiltersCount : undefined}
        filterChanged={activeFiltersCount > 0}
        selected={isFiltersPopupOpen}
        onPress={() => {}}
        testID="table-filters-button"
      />
    </Popup>
  );
};
